// extracted by mini-css-extract-plugin
export default {"img":"SponsorsSection_img__K2iJS","qualcommimg":"SponsorsSection_qualcommimg__mNqTq"};